import { ref, onMounted, computed } from "vue";

export default function useSelectList({
  items,
  defaultItem = "",
  isMultiSelect = false,
  maxItems,
}) {
  const selectedSingle = ref("");
  const selectedMulti = ref([]);
  const counterIndex = ref(0);
  const selectList = ref([]);
  const isOpen = ref(false);
  const isMultiMode = isMultiSelect;
  const allowSorting = ref(true);
  const allowedMax = maxItems;
  const listHasOneItem = computed(() => selectList.value.length === 1);

  const toggleSelect = (open) => {
    isOpen.value = typeof open === "boolean" ? open : !isOpen.value;
  };

  const goToNextEl = () => {
    // TODO: Since this is also used by tab, need to account for when shift+tab is pressed.
    // Otherwise desyncs the selected element and the element that's selected when enter is pressed.
    if (counterIndex.value < selectList.value.length) {
      counterIndex.value++;
    }
  };

  const goToPreviousEl = () => {
    if (counterIndex.value > 0) {
      counterIndex.value--;
    }
  };

  const selectElOnClick = (item) => {
    if (
      isMultiMode &&
      !selectedMulti.value.includes(item) &&
      selectedMulti.value.length < allowedMax
    ) {
      selectedMulti.value.push(item);
    } else {
      selectedSingle.value = item;
    }

    toggleSelect(false);
    counterIndex.value = 0;
  };

  const selectEl = () => {
    const item = selectList.value[counterIndex.value];
    selectElOnClick(item);
  };

  const updateCurrentList = (listItems, defaultProp) => {
    const defaultItemProp = defaultProp || listItems[0];
    selectList.value = allowSorting.value ? listItems.sort() : listItems;

    if (!defaultItemProp) {
      return;
    }

    if (isMultiMode) {
      selectedMulti.value.push(defaultItemProp);
    } else {
      selectedSingle.value = defaultItemProp;
    }
  };

  const deselectElement = (index) => {
    selectedMulti.value.splice(index, 1);
  };

  const handleClickOutside = () => {
    toggleSelect(false);
  };

  const toggleSort = (toSort) => {
    allowSorting.value = toSort;
  };

  // set defaults
  onMounted(() => {
    updateCurrentList(items, defaultItem);
  });

  return {
    isOpen,
    counterIndex,
    selectList,
    goToNextEl,
    selectEl,
    deselectElement,
    selectElOnClick,
    goToPreviousEl,
    selectedSingle,
    selectedMulti,
    toggleSelect,
    updateCurrentList,
    listHasOneItem,
    handleClickOutside,
    toggleSort,
  };
}
